import type { ActivityId } from '#server/types/activity'
import { getEndpointPathBuilders } from './endpoint.ts'

const { action } = getEndpointPathBuilders('activitypub')

export default {
  activityById (id: ActivityId) {
    return action('activity', { id })
  },
  followers (params) { return action('followers', params) },
}
